module.exports = __webpack_public_path__ + "media/open8.c438a1c4.mp3";